import React, { useState, useEffect } from "react";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.pageYOffset > 300);
    };

    window.addEventListener("scroll", toggleVisibility, {
      passive: true,
    });

    toggleVisibility();

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  // Hide button when door modal is open
  useEffect(() => {
    const checkModal = () => {
      setHidden(
        document.body.classList.contains("door-modal-open")
      );
    };

    checkModal();

    const observer = new MutationObserver(checkModal);

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  const scrollAction = () => {
    if (!visible) {
      window.scrollTo({
        top: window.innerHeight,
        behavior: "smooth",
      });
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  if (hidden) return null;

  return (
    <>
      <style>{`
        .scroll-btn {
          position: fixed;
          bottom: 25px;
          right: 25px;
          z-index: 9999;
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: #000;
          color: #fc7303;
          border: 2px solid #fc7303;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 4px 15px rgba(0,0,0,0.35);
          transition: all 0.3s ease;
        }

        .scroll-btn:hover {
          background: #fc7303;
          color: #000;
          box-shadow: 0 0 20px rgba(252,115,3,0.5);
          transform: translateY(-3px);
        }

        .scroll-btn.down-mode svg {
          animation: bounceDown 1.5s infinite;
        }

        .scroll-btn.up-mode svg {
          animation: pulseUp 1.5s infinite;
        }

        @keyframes bounceDown {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(6px);
          }
        }

        @keyframes pulseUp {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-4px);
          }
        }

        @media (max-width: 768px) {
          .scroll-btn {
            width: 42px;
            height: 42px;
            bottom: 20px;
            right: 20px;
          }
        }
      `}</style>

      <button
        onClick={scrollAction}
        aria-label={visible ? "Scroll to top" : "Scroll down"}
        className={`scroll-btn ${visible ? "up-mode" : "down-mode"}`}
      >
        {visible ? <FaArrowUp size={18} /> : <FaArrowDown size={18} />}
      </button>
    </>
  );
};

export default ScrollToTopButton;